/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Trail_EmptyInputs */

const cs_gdpr_trail_empty = /** @type {(inputs: Gdpr_Trail_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné záznamy.`)
};

const en_gdpr_trail_empty = /** @type {(inputs: Gdpr_Trail_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No entries.`)
};

/**
* | output |
* | --- |
* | "No entries." |
*
* @param {Gdpr_Trail_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_trail_empty = /** @type {((inputs?: Gdpr_Trail_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Trail_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_trail_empty(inputs)
	return cs_gdpr_trail_empty(inputs)
});